export { default, getServerSideProps } from '../[itemID]/reviews/index';
